module.exports = __webpack_public_path__ + "img/wp12.71c093fa.jpeg";